module.exports = __webpack_public_path__ + "img/ea2e96b.jpg";